<template>
  <div class="zlt-container" :style="styles" @click="handleViewDetail">
    <div class="header">
      <div class="item start-address">
        {{ item.startProvince }} {{ item.startCity }}
      </div>
      <img src="../../assets/Bluearrow.png" alt="" class="arrow-icon" />
      <div class="item end-address">
        {{ item.endProvince }} {{ item.endCity }}
      </div>
    </div>
    <slot></slot>
    <div class="footer">
      <div class="name">{{ item.carriertype }} {{ item.carrier }}</div>
      <img src="../../assets/zhuXTlogo.png" class="logo" alt="" />
      <img src="../../assets/rightArrow.png" alt="" class="arrow-icon" />
      <div class="btns">
        <button class="btn" @click.stop="baojie">包接</button>
        <button class="btn">包送</button>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script lang="ts" setup>
  import {
    computed,
    defineProps,
    withDefaults,
    type CSSProperties,
    type ComputedRef,
  } from 'vue';
  import { useRouter } from 'vue-router';

  const router = useRouter();

  // 定义props类型,接收数据
  interface Item {
    id: string | number;
    name?: string;
    startProvince?: string;
    startCity?: string;
    endProvince?: string;
    endCity?: string;
    carrier?: string;
    carriertype?: string;
  }

  const props = withDefaults(
    defineProps<{
      width?: number;
      url?: string;
      ptype1?: string;
      item: Item; // 接收物流数据
    }>(),
    {
      width: 434,
      item: () => ({}) as Item, // 默认值为空对象
    },
  );

  const styles: ComputedRef<CSSProperties> = computed(() => {
    return {
      width: props.width + 'px',
    };
  });

  const handleViewDetail = () => {
    props.url && router.push(props.url);
  };

  const baojie = () => {
    alert('包接');
  };
</script>

<style lang="scss" scoped>
  .zlt-container {
    position: relative;
    padding: 39px 24px 24px;
    background: linear-gradient(180deg, #f1f7ff 0%, #f1f7ff 100%);
    cursor: pointer;

    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 4px;
      z-index: 1;
      opacity: 0;
      opacity: 0;
      background-color: transparent;
    }

    &:hover {
      background: linear-gradient(180deg, #f1f6ff 0%, #ffffff 100%);
      box-shadow: 0px 10px 16px 0px rgba(0, 27, 81, 0.2);

      &::after {
        opacity: 1;
        background-color: #076aff;
      }
    }

    .header {
      display: flex;
      align-items: center;

      .arrow-icon {
        width: 30px;
        height: 10px;
        margin: 0 24px 0 30px;
      }

      .item {
        $IconSize: 24px;
        $IconSpace: 16px;

        position: relative;
        text-align: left;
        padding-left: $IconSize + $IconSpace;
        color: #001b51;
        flex: 1;
        font-size: 20px;
        font-weight: 500;

        &::before {
          content: '始';
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          width: $IconSize;
          height: $IconSize;
          left: 0;
          border-radius: 3.43px;
          top: 50%;
          transform: translateY(-50%);
          text-align: center;
          font-size: 13.7px;
          color: #fff;
          background-color: #1dc054;
        }

        &.end-address {
          &::before {
            content: '终';
            background-color: #f4333c;
          }
        }
      }
    }

    .footer {
      display: flex;
      align-items: center;
      color: #001b51;
      margin-top: 13px;
      padding: 8px 0 8px 16px;
      background: linear-gradient(
        90deg,
        #e0edff 44%,
        rgba(224, 237, 255, 0) 100%
      );

      .name {
        margin-right: 8px;
      }

      .logo {
        width: 72px;
        height: 30px;
        margin-right: 8px;
        flex-shrink: 0;
      }

      .arrow-icon {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
      }

      .btns {
        flex: 1;
        text-align: right;

        .btn {
          padding: 2px 8px;
          color: #fff;
          font-size: 14px;
          font-weight: 500;
          background-color: #005dff;
          margin-right: 7px;

          &:nth-child(2) {
            background-color: #1dc054;
            margin-right: 0;
          }
        }
      }
    }
  }
</style>
